import {
  createChartSlide,
  createComboChartSlide,
  createLineChartSlide,
  createScatterChartSlide,
} from '../helpers/chart_slide';
import { PRESENTATION_CHART_TYPES } from '../model';

const toChart = (slide) => ({
  barDir: slide.chartType === PRESENTATION_CHART_TYPES.BAR ? 'bar' : 'col',
  barGrouping: slide.stacking === 'percent' ? 'percentStacked' : slide.stacking,
  comparisonValues: slide.comparisonValues,
  format:
    slide.chartType === PRESENTATION_CHART_TYPES.COMBO ? slide.valueFormats : slide.valueFormat,
  series: slide.series.map((series) => ({ data: series.values, name: series.name })),
  xAxis: { categories: slide.categories },
});

const toScatterChart = (slide) => ({
  formatX: slide.xValueFormat,
  formatY: slide.valueFormat,
  nameX: slide.xAxisTitle,
  nameY: slide.yAxisTitle,
  series: slide.series.map((series) => ({
    data: series.values.map((point) => ({
      name: point.label || point.name || '',
      x: point.x,
      y: point.y,
    })),
    name: series.name,
  })),
  showRegressionLine: slide.showRegressionLine,
  xMax: slide.xMax,
  xMin: slide.xMin,
  yMax: slide.yMax,
  yMin: slide.yMin,
});

export const renderChartSlide = ({ footer, pptx, slide }) => {
  const props = {
    ...footer,
    pptx,
    readAs: slide.insight,
    slideTitle: slide.title,
  };

  switch (slide.chartType) {
    case PRESENTATION_CHART_TYPES.BAR:
    case PRESENTATION_CHART_TYPES.COLUMN:
      return createChartSlide({ ...props, chart: toChart(slide) });
    case PRESENTATION_CHART_TYPES.COMBO:
      return createComboChartSlide({ ...props, chart: toChart(slide) });
    case PRESENTATION_CHART_TYPES.LINE:
      return createLineChartSlide({ ...props, chart: toChart(slide) });
    case PRESENTATION_CHART_TYPES.SCATTER:
      return createScatterChartSlide({ ...props, chart: toScatterChart(slide) });
    default:
      throw new TypeError(`Unsupported canonical chart type: ${slide.chartType}`);
  }
};
